import find from 'lodash/find';
import React from 'react';
import { PreviewOptions, PreviewTypes } from '../../data/settings';
import ModalModule from '../../modal';
import UI from '../../ui';
import Utils from '../../utils';

const { Spinner } = UI;
const { Modal, ModalButtonActionType } = ModalModule;
const { Communication } = Utils;

class PreviewLabelImageModal extends React.Component {
	constructor(props) {
		super(props);

		const {
			data: { type = PreviewTypes.Label },
		} = props;
		const { text } = find(PreviewOptions, { type });

		this.state = {
			header: `${text} Preview`,
			imageUrl: '',
			mask: true,
		};
	}

	componentDidMount = async () => {
		const {
			data: { type, showError },
		} = this.props;

		const response = await this.getPreviewResponse(type);

		if (Communication.isSuccessful(response)) {
			const {
				data: { URL: imageUrl },
			} = response;

			this.setState({
				imageUrl,
				mask: false,
			});
		} else {
			showError({ response });
		}
	};

	getPreviewLabelImage = () => {
		const { data } = this.props;
		const {
			customerID,
			emailTo,
			labelCustomizationImageId,
			shipDate,
			printImageOnLabelsAndEnvelopes,
		} = data;

		/**
		 * Note: the following payload is referencing to the payload used in /ajax/CreateIndicium.aspx
		 */
		const previewLabelImageInput = {
			costCodeID: 0,
			CustomerID: customerID,
			Customs: '',
			deliveryNotification: emailTo === '1',
			EltronPrinterDPType: 'Default',
			integratorTxId: '00000000-0000-0000-0000-000000000000',
			keepUrlSplit: false,
			labelColumn: 1,
			labelRow: 1,
			Reference1: '',
			memo: '',
			NonDeliveryOption: 'Return',
			OrderID: '',
			printerName: null,
			printerOrientation: 'default',
			printerTray: null,
			printInstructions: false,
			PrintLayout: 'Normal4X6',
			recipientEmail: '',
			rotationDegrees: 0,
			SampleOnly: true,
			TrackingNumber: '',
			verticalOffset: 0,
			ImageType: 'png',
			ReturnTo: {
				FullName: 'Jane Sender',
				Address1: '4301 Bull Creek Rd Ste 300',
				City: 'Austin',
				State: 'TX',
				Zip: '78731',
				ZIPCode: '78731',
				ZIPCodeAddOn: '5937',
				Country: 'US',
			},
			Rate: {
				From: {
					FullName: 'Jane Sender',
					Address1: '4301 Bull Creek Rd Ste 300',
					City: 'Austin',
					State: 'TX',
					Zip: '78731',
					ZIPCode: '78731',
					ZIPCodeAddOn: '5937',
					Country: 'US',
				},
				To: {
					FullName: 'John Recipient',
					Address1: '4301 Bull Creek Rd Ste 300',
					City: 'Austin',
					State: 'TX',
					Zip: '78731',
					ZIPCode: '78731',
					ZIPCodeAddOn: '5937',
					Country: 'US',
				},
				Amount: 0,
				ServiceType: 'USFC',
				DeliverDays: null,
				Error: null,
				WeightLb: 0,
				WeightOz: 0,
				PackageType: 'ThickEnvelope',
				ShipDate: shipDate,
				ShipDateSpecified: true,
				InsuredValue: 0,
				RegisteredValue: 0,
				CODValue: 0,
				DeclaredValue: 1,
				RectangularShaped: true,
				Prohibitions: null,
				Restrictions: null,
				Observations: null,
				Regulations: null,
				GEMNotes: null,
				MaxDimensions: null,
				DimWeighting: null,
				AddOns: [
					{
						AddOnType: 'SCAHP',
						Amount: 0,
					},
				],
				EffectiveWeightInOunces: 0,
				IsIntraBMC: false,
				Zone: 0,
				RateCategory: 0,
				Length: 0,
				Width: 0,
				Height: 0,
				NonMachinable: false,
				PrintLayout: 'Normal4X6',
			},
			ImageID:
				printImageOnLabelsAndEnvelopes === '1'
					? labelCustomizationImageId
					: '0',
			printerPaperHeight: 6,
			printerPaperWidth: 4,
		};
		return Communication.createIndicium(previewLabelImageInput);
	};

	getPreviewEnvelopeImage = () => {
		const { data } = this.props;
		const {
			customerID,
			labelCustomizationImageId,
			printImageOnLabelsAndEnvelopes,
			shipDate,
		} = data;

		/**
		 * Note: the following payload is referencing to the payload used in /ajax/CreateIndicium.aspx
		 */
		const previewLabelImageInput = {
			costCodeID: 0,
			CustomerID: customerID,
			deliveryNotification: false,
			EltronPrinterDPType: 'Default',
			integratorTxId: '00000000-0000-0000-0000-000000000000',
			ImageID:
				printImageOnLabelsAndEnvelopes === '1'
					? labelCustomizationImageId
					: '0',
			keepUrlSplit: false,
			landscape: 'default',
			labelColumn: 1,
			labelRow: 1,
			hideFIM: true,
			Reference1: '',
			memo: '',
			printMemo: false,
			NonDeliveryOption: 'Return',
			OrderID: '',
			printerName: null,
			printerOrientation: 'portrait',
			printerTray: null,
			printInstructions: false,
			PrintLayout: 'Envelope10',
			recipientEmail: '',
			rotationDegrees: 0,
			SampleOnly: true,
			TrackingNumber: '',
			verticalOffset: 0,
			ImageType: 'gif',
			ReturnTo: {
				FullName: 'Jane Sender',
				Address1: '4301 Bull Creek Rd Ste 300',
				City: 'Austin',
				State: 'TX',
				Zip: '78731',
				ZIPCode: '78731',
				ZIPCodeAddOn: '5937',
				Country: 'US',
				PhoneNumber: '5625551212',
			},
			Rate: {
				From: {
					FullName: 'Jane Sender',
					Address1: '4301 Bull Creek Rd Ste 300',
					City: 'Austin',
					State: 'TX',
					Zip: '78731',
					ZIPCode: '78731',
					ZIPCodeAddOn: '5937',
					Country: 'US',
					PhoneNumber: '5625551212',
				},
				To: {
					FullName: 'John Recipient',
					Address1: '4301 Bull Creek Rd Ste 300',
					City: 'Austin',
					State: 'TX',
					Zip: '78731',
					ZIPCode: '78731',
					ZIPCodeAddOn: '5937',
					Country: 'US',
				},
				Amount: 0,
				ServiceType: 'USFC',
				DeliverDays: null,
				Error: null,
				WeightLb: 0,
				WeightOz: 1,
				PackageType: 'Letter',
				ShipDate: shipDate,
				ShipDateSpecified: true,
				InsuredValue: 0,
				RegisteredValue: 0,
				CODValue: 0,
				DeclaredValue: 1,
				RectangularShaped: true,
				Prohibitions: null,
				Restrictions: null,
				Observations: null,
				Regulations: null,
				GEMNotes: null,
				MaxDimensions: null,
				DimWeighting: null,
				AddOns: [],
				EffectiveWeightInOunces: 0,
				IsIntraBMC: false,
				Zone: 0,
				RateCategory: 0,
				Length: 0,
				Width: 0,
				Height: 0,
				NonMachinable: false,
				PrintLayout: 'Envelope10',
			},
			createMode: 'Preview',
			PrintFromAddress: true,
			PrintToAddress: true,
		};

		return Communication.createEnvelopeIndicium(previewLabelImageInput);
	};

	getPreviewReturnLabelImage = () => {
		const { data } = this.props;
		const {
			customerID,
			emailTo,
			labelCustomizationImageId,
			settingsReference,
			settingsInstructions,
			shipDate,
			printImageOnLabelsAndEnvelopes,
		} = data;

		const memo = `\t${settingsReference || ''}\r\n${settingsInstructions || ''}`;

		/**
		 * Note: the following payload is referencing to the payload used in /ajax/CreateIndicium.aspx
		 */
		const previewLabelImageInput = {
			costCodeID: 0,
			CustomerID: customerID,
			Customs: '',
			deliveryNotification: emailTo === '1',
			EltronPrinterDPType: 'Default',
			integratorTxId: '00000000-0000-0000-0000-000000000000',
			keepUrlSplit: false,
			labelColumn: 1,
			labelRow: 1,
			Reference1: '',
			memo: this.mapLabelMessage(memo),
			printMemo: true,
			NonDeliveryOption: 'Return',
			OrderID: '',
			printerName: null,
			printerOrientation: 'default',
			printerTray: null,
			printInstructions: false,
			PrintLayout: 'Return',
			recipientEmail: '',
			rotationDegrees: 0,
			SampleOnly: true,
			TrackingNumber: '',
			verticalOffset: 0,
			ImageType: 'png',
			ImageID:
				printImageOnLabelsAndEnvelopes === '1'
					? labelCustomizationImageId
					: '0',
			ReturnTo: {
				FullName: 'John Recipient',
				Address1: '4301 Bull Creek Rd Ste 300',
				City: 'Austin',
				State: 'TX',
				Zip: '78731',
				ZIPCode: '78731',
				ZIPCodeAddOn: '5937',
				Country: 'US',
			},
			Rate: {
				From: {
					FullName: 'John Recipient',
					Address1: '4301 Bull Creek Rd Ste 300',
					City: 'Austin',
					State: 'TX',
					Zip: '78731',
					ZIPCode: '78731',
					ZIPCodeAddOn: '5937',
					Country: 'US',
				},
				To: {
					FullName: 'Jane Sender',
					Address1: '4301 Bull Creek Rd Ste 300',
					City: 'Austin',
					State: 'TX',
					Zip: '78731',
					ZIPCode: '78731',
					ZIPCodeAddOn: '5937',
					Country: 'US',
				},
				Amount: 0,
				ServiceType: 'USFC',
				DeliverDays: null,
				Error: null,
				WeightLb: 0,
				WeightOz: 2,
				PackageType: 'Package',
				ShipDate: shipDate,
				ShipDateSpecified: true,
				InsuredValue: 0,
				RegisteredValue: 0,
				CODValue: 0,
				DeclaredValue: 1,
				RectangularShaped: true,
				Prohibitions: null,
				Restrictions: null,
				Observations: null,
				Regulations: null,
				GEMNotes: null,
				MaxDimensions: null,
				DimWeighting: null,
				AddOns: [
					{
						AddOnType: 'USAPOUR',
					},
				],
				EffectiveWeightInOunces: 0,
				IsIntraBMC: false,
				Zone: 0,
				RateCategory: 0,
				Length: 0,
				Width: 0,
				Height: 0,
				NonMachinable: false,
				PrintLayout: 'Return',
			},
			ServiceType: 'USFC',
			PackageType: 'Package',
			printerPaperHeight: 6,
			printerPaperWidth: 4,
			OutboundTransactionID: '00000000-0000-0000-0000-000000000000',
		};

		return Communication.createIndicium(previewLabelImageInput);
	};

	getPreviewResponse = type => {
		if (type === PreviewTypes.Label) {
			return this.getPreviewLabelImage();
		} else if (type === PreviewTypes.Envelope) {
			return this.getPreviewEnvelopeImage();
		} else if (type === PreviewTypes.ReturnLabel) {
			return this.getPreviewReturnLabelImage();
		}
	};

	/**
	 * Note : the following logic is referencing to `_mapLabelMessage` method in print.js from Ext code
	 * maps the custom label message variables to the order fields
	 * @param {string} message
	 */
	mapLabelMessage = message => {
		let mappedMessage = message;

		/**
		 * creating a mapping with dummy values to show preview
		 * the mapping is based on the dummy values from `onPreviewReturnLabel` handler in `LabelCustomizationTabViewController.js` from Ext code
		 */
		const messageVarMap = [
			['[Order #]', '123456'],
			['[Ship Date]', '01/21/1999'],
			['[Order Date]', '01/21/1999'],
			['[Sku #1]', '4x tee-xl'],
			['[Sku #2]', '5x tee-m'],
			['[Sku #3]', '6x tee-s'],
			['[Product #1]', '4x Hero Tee'],
			['[Product #2]', '5x Hero Tee'],
			['[Product #3]', '6x Hero Tee'],
			['[Dimensions]', '0" x 0" x 0"'],
			['[Weight]', '0 lbs. 2 oz.'],
			['[Notes from Customer]', 'No tomatoes, please!'],
			['[Warehouse Loc #1]', '4x B7'],
			['[Warehouse Loc #2]', '5x B8'],
			['[Warehouse Loc #3]', '6x B9'],
		];

		// loop through each message variable mapping item
		messageVarMap.forEach(item => {
			const reReplace = `\\[${item[0].replace(/[[\]]+/g, '')}\\]`;
			const re = new RegExp(reReplace, 'g');
			mappedMessage = mappedMessage.replace(re, item[1]);
		});

		return mappedMessage;
	};

	renderPreviewImage = () => {
		const { imageUrl, header, mask } = this.state;
		const {
			data: { type },
		} = this.props;

		if (mask) {
			return <Spinner msg="Loading image" />;
		} else {
			return (
				<img
					className="preview-image"
					style={{
						width: type === PreviewTypes.Envelope ? '100%' : 'auto',
						height: 'auto',
					}}
					alt={header}
					src={imageUrl}
				/>
			);
		}
	};

	render() {
		const { modalId } = this.props;
		const { header } = this.state;

		return (
			<Modal
				modalId={modalId}
				className="common-settings preview-label-image-modal"
				header={header}
				size="large"
				primaryButton={{
					type: ModalButtonActionType.Ok,
					text: 'Close',
				}}
			>
				<div className="preview-label-image-modal-container">
					{this.renderPreviewImage()}
				</div>
			</Modal>
		);
	}
}

export default PreviewLabelImageModal;
